import { render, staticRenderFns } from "./AggregateSkippedSettlementDetail.vue?vue&type=template&id=0de89afe"
import script from "./AggregateSkippedSettlementDetail.vue?vue&type=script&lang=js"
export * from "./AggregateSkippedSettlementDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports